module.exports = __webpack_public_path__ + "img/ic_bluepeople copy.7458cfc3.svg";